import ReactMarkdown from 'react-markdown'
import { getCurrentTosEffectiveDate } from 'lib/helpers/getCurrentTosEffectiveDate/getCurrentTosEffectiveDate'
import ToSText2026_03_19 from 'md/terms-of-service/terms-of-service-2026-03-19.md'
import ToSText2026_09_15 from 'md/terms-of-service/terms-of-service-2026-09-15.md'

export const TermsOfServiceMarkdown = () => {
  const currentTosEffectiveDate = getCurrentTosEffectiveDate()

  if (currentTosEffectiveDate === '2026-09-15') {
    return <ReactMarkdown>{ToSText2026_09_15}</ReactMarkdown>
  }

  return <ReactMarkdown>{ToSText2026_03_19}</ReactMarkdown>
}
